const CustomButton = ({
  text,
  icon,
  href,
  onClick,
  type = "button",
  colorClass = "green-bg text-white",
}) => {
  const Component = href ? "a" : "button";

  return (
    <Component
      type={Component === "button" ? type : undefined}
      href={href}
      onClick={onClick}
      aria-label={text}
      className={`btn ${colorClass} rounded-5 px-4 py-2 fs-6 w-sm-auto custom-btn d-inline-flex align-items-center border-bottom-left`}
    >
      {text}
      {icon && <span className="ms-2 d-flex align-items-center">{icon}</span>}
    </Component>
  );
};

export default CustomButton;